let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gRb4i"), load("amEt1"), load("19uFC"), load("hhss7"), load("iV6RN")]).then(() => parcelRequire('kPKkS'));